import { render, staticRenderFns } from "./PopupMenuBody.vue?vue&type=template&id=cc9830d0&scoped=true&"
import script from "./PopupMenuBody.vue?vue&type=script&lang=ts&"
export * from "./PopupMenuBody.vue?vue&type=script&lang=ts&"
import style0 from "./PopupMenuBody.vue?vue&type=style&index=0&id=cc9830d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9830d0",
  null
  
)

export default component.exports